import {FeatureFlagDataState, FeatureFlagListItem, featureFlagStore} from './feature-flag.store';
import {Injectable} from '@angular/core';
import {select} from '@ngneat/elf';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class FeatureFlagQuery {
  public featureList$: Observable<FeatureFlagListItem[]>;
  // [NEW-GROUP] - disabled for ticket DASH-1168
  // public groupsFeature$: Observable<boolean>;

  constructor() {
    this.featureList$ = featureFlagStore.pipe(
      select(state => {
        return Object.keys(state).map(key => {
          const feature = state[key];
          return {
            key,
            ...feature,
          };
        });
      }),
    );
    // [NEW-GROUP] - disabled for ticket DASH-1168
    // this.groupsFeature$ = featureFlagStore.pipe(select((state: FeatureFlagDataState) => state.groupsFeature.value));
  }
}
